import { ref, reactive } from "vue"

/**
 * Form fields, files and restrictions controller and validator
 *
 */
class Form {

  /**
   *
   */
  constructor () {
    this.files = reactive({})
    this.fields = ref([])
    this.restrictions = ref({})
    this.field = new Proxy(this.fields, {
      get (targetRef, key) {
        // targetRef is "this.fields". We look inside its ".value"
        for (const i in targetRef.value) {
          if (targetRef.value[i] && targetRef.value[i].values) {
            const find = targetRef.value[i].values.find(el => el.key === key)
            if (find) return find
          }
        }
        return null
      }
    })
  }

  /**
   *
   * @param  {...any} names
   *
   * @returns {Object}
   */
  addFiles (...names) {
    for (const item of names) {
      if (typeof item === 'string') {
        this.files[item] = { file: null, error: null, /*required: true, */ hidden: false, optional: false }
      } else if (typeof item === 'object') {
        for (const name in item) {
          this.files[name] = Object.assign({ file: null, error: null, /*required: true, */ hidden: false, optional: false }, item[name])
        }
      }
    }

    return this.files
  }

  /**
   *
   * @param  {...any} names
   *
   * @returns {Object}
   */
  addRestrictions(...names) {
    for (const item of names) {
      if (typeof item === 'string') {
        this.restrictions.value[item] = false
      }
    }
    return this.restrictions
  }

  /**
   *
   */
  restrictionsComplete () {
    return Object.values(this.restrictions.value).reduce((result, val) => result && val)
  }

  /**
   *
   * @param {Array} list
   * @returns
   */
  addFields (list) {
    this.fields.value = list
    return this.fields
  }

  /**
   *
   * @returns {Array}
   */
  getFields () {
    const result = []
    for (const i in this.fields.value) {
      const values = this.fields.value[i].values.filter(el => !el.hidden)
      if (values.length) {
        result.push(Object.assign({}, this.fields.value[i], { values }))
      }
    }
    return result
  }

  /**
   *
   * @param Array items
   * @param Object files
   *
   * @returns {Boolean}
   */
  validate(items, files = {}) {
    items = items || this.fields
    files = files || this.files
    let error = false
    const result = {}
    for (let i = 0; i <= items.length - 1; i++) {
      // const group = items[i].values
      for (let j = 0; j <= items[i].values.length - 1; j++) {
        const field = items[i].values[j]
        if (field.optional || field.hidden) continue
        if (field.value === "") {
          field.error = true
          error = true
        } else {
          field.error = false
        }
        result[field.key] = field.value
      }
    }

    for (const name in files) {
      // if (files[name].required && !files[name].file) {
      if (!files[name].hidden && !files[name].optional && !files[name].file) {
        files[name].error = error = true
      }
    }

    return error ? false : result
  }

  /**
   *
   * @returns {Object} Files values
   */
  getPayloadFiles () {
    const payload = {}
    for (const name in this.files) {
      if (this.files[name].file) {
        payload[name] = this.files[name].file
      }
    }

    return payload
  }

  /**
   *
   * @returns {Object} Fields values
   */
  getPayloadFields () {
    const payload = {}
    for (let i = 0; i <= this.fields.value.length - 1; i++) {
      for (let j = 0; j <= this.fields.value[i].values.length - 1; j++) {
        const field = this.fields.value[i].values[j];
        payload[field.key] = field.value;
      }
    }

    return payload
  }

  /**
   *
   * @returns {Object} Fields and files values
   */
  getPayload () {
    return Object.assign({}, this.getPayloadFields(), this.getPayloadFiles())
  }
}

export default () => {
  return new Form
}